class QuickLinks extends HTMLElement {
  constructor() {
    super();
    this.toc = null;
    this.tocList = null;
  }

  connectedCallback() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.initialize());
    } else {
      this.initialize();
    }
  }

  initialize() {
    const selectors = this.getAttribute("selectors");

    if (!selectors) {
      console.warn("QuickLinks: No selectors provided");
      return;
    }
    this.toc = this.querySelector(".toc");
    if (!this.toc) {
      this.toc = document.createElement("div");
      this.toc.className = "toc";
      this.appendChild(this.toc);
    }

    this.tocList = document.createElement("ol");
    this.generateTOC(selectors);
  }

  generateTOC(selectorsString) {
    const selectors = selectorsString.split(",");
    let headers = [];
    const showNumbers = this.getAttribute("data-collection-style") === "1";

    // Run the query for each selector separately and add the results to the headers array
    selectors.forEach((selector) => {
      const content = document.querySelector(selector.trim());
      if (content) {
        const selectorHeaders = content.querySelectorAll(
          "h2:not(.ignore_heading)"
        );
        headers = [...headers, ...selectorHeaders];
      }
    });

    headers.forEach((header, index) => {
      // Check if the header's content is not empty
      if (header.innerText.trim() !== "") {
        // Add id to each header
        const id = `heading-${index}`;
        header.id = id;

        // Create TOC entry
        const tocEntry = document.createElement("a");
        tocEntry.href = `#${id}`;
        
        if (showNumbers) {
          const numberSpan = document.createElement("span");
          numberSpan.className = "toc-number";
          numberSpan.textContent = `${index + 1}. `;
          tocEntry.appendChild(numberSpan);
        }

        const textSpan = document.createElement("span");
        textSpan.className = "toc-text";
        textSpan.textContent = header.innerText;
        tocEntry.appendChild(textSpan);

        tocEntry.addEventListener("click", (event) => {
          event.preventDefault();
          const target = document.getElementById(id);
          if (target) {
            target.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        });

        // Create list item and append the link
        const tocItem = document.createElement("li");
        tocItem.appendChild(tocEntry);

        // Append the list item to the ordered list
        this.tocList.appendChild(tocItem);
      }
    });

    // Append the ordered list to the TOC container
    this.toc.appendChild(this.tocList);
  }
}

customElements.define("quick-links", QuickLinks);
